/**
 * Formats an elapsed-millisecond duration as MM:SS. Negative inputs clamp to 0.
 */
export const formatElapsedMs = (elapsedMs: number): string => {
  const safeMs = Math.max(0, elapsedMs);
  const minutes = Math.floor(safeMs / 60000);
  const seconds = Math.floor((safeMs % 60000) / 1000);

  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};
